import tagApi from "../api/requests/tagReqs";

export function tagList () {
  return tagApi.list();
}
